import {
    createDataMapper,
    transformSourceToTargetKeys,
} from '@common/utils/query/dataMappers';
import { mergeWithDefault } from '@common/utils/mergeWithDefault';
import { CLIP_KEYS } from '../constants';
import { BackendSearchClip, Clip, DEFAULT_CLIP } from '../types';
import { mapSearchMediaIdentifiers } from './media.mappers';

const capitalize = <T extends string>(s: T) =>
    (s[0].toUpperCase() + s.slice(1).toLowerCase()) as Capitalize<typeof s>;

function parseEpisode(input: string): string {
    const regexp = /^\[(.*?)]\s*(.*)$|^\{-(.*?)-}\s*(.*)$/;

    const match = input.match(regexp);

    if (!match) return capitalize(input);

    if (match[1] !== undefined) {
        return capitalize(match[2]);
    } else if (match[3] !== undefined) {
        return capitalize(match[4]);
    }
    return capitalize(input);
}

export const mapSearchClipToFrontend = (raw: BackendSearchClip): Clip => {
    const transformed = mergeWithDefault(
        transformSourceToTargetKeys(raw, CLIP_KEYS),
        DEFAULT_CLIP,
    );

    const availableFlags =
        raw.materialInfo_flag_onFlow || raw.materialInfo_flag_online || [];

    const flagsArray = Array.isArray(availableFlags)
        ? availableFlags
        : [availableFlags];
    const hasProxy = flagsArray.some((flag) =>
        String(flag).startsWith('PROXY;'),
    );

    const mediaIdentifiers = mapSearchMediaIdentifiers(
        raw.mediaObjectId,
        raw.moiInfo,
        availableFlags,
    );

    const episode = parseEpisode(raw.cf_s_value_episode ?? '');

    return {
        ...transformed,
        id: transformed.id.replace('Annotation_', ''),
        collectionId: raw.attachedEditorialObjectParentId?.[0] || '',
        episode,
        mediaIdentifiers,
        hasProxy,
    };
};

export const transformClip = createDataMapper<BackendSearchClip, Clip>(
    mapSearchClipToFrontend,
    true,
);
